/**
  * @Name: 路由权限配置
  * @Description: 路由权限配置
  * @params: *
  * @return: *
  * @author: 抠脚老汉
  * @date: 4/20/23
 */
import router from './router'
import store from './store'
import { Message, MessageBox } from "element-ui";
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { getToken } from "./utils/auth";

NProgress.configure({ showSpinner: false })

router.beforeEach((to, from, next) => {
  NProgress.start()
  document.title = to.meta.title || '招标采购行业信用平台 - 全国免费查询企业工商信息'
  document.body.scrollTop = 0
  document.documentElement.scrollTop = 0
  const hasToken = getToken()
  next()
  return false
  if (hasToken || to.path === '/') {
    next()
    NProgress.done()
  } else {
    next('/')
    NProgress.done()
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
